import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { QRCodeSVG as QRCode } from 'qrcode.react';
import { getTodayArrivals, generateToken } from '../api';

const HOTELS = [
  { id: 46844, name: 'Бутик отель Номера' },
  { id: 12076, name: 'Номера у Эрмитажа' },
  { id: 13328, name: 'Номера у Невы' },
  { id: 13400, name: 'Номера на Сенной' },
  { id: 18312, name: 'Номера на Благодатной' },
  { id: 30606, name: 'Голден Отель' },
  { id: 46850, name: 'Номера на Жуковского' },
  { id: 46851, name: 'Апартаменты Брискорн' },
  { id: 46852, name: 'Номера на Площади Восстания' },
  { id: 46854, name: 'Апартаменты Селект' },
  { id: 46895, name: 'Номера на Гончарной' },
  { id: 46896, name: 'Номера на Невском 111' },
  { id: 49000, name: 'Номера на Пирогова' },
  { id: 52055, name: 'Номера на Балтийской' },
  { id: 53153, name: 'Трауберг' },
  { id: 55427, name: 'Номера на Морской' },
  { id: 56423, name: 'Номера на Фонтанке' },
  { id: 57201, name: 'Номера в Гатчине' },
  { id: 57216, name: 'Номера у Морского вокзала' },
  { id: 57392, name: 'Номера в Твери' },
  { id: 58879, name: 'Усадьба Лебяжье' },
  { id: 9718,  name: 'Номера в Петергофе' },
  { id: 5453,  name: 'Номера в Пушкине' },
  { id: 8181,  name: 'Номера в Стрельне' },
  { id: 46953, name: 'Номера на Репина' },
  { id: 71126, name: 'Номера на Рыбинской' },
];

export default function AdminPage() {
  const [hotelId, setHotelId] = useState(46844);
  const [arrivals, setArrivals] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [qrData, setQrData] = useState(null);
  const [generating, setGenerating] = useState(null);
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('rc_user') || 'null');

  useEffect(() => { loadArrivals(); }, [hotelId]);

  async function loadArrivals(refresh = false) {
    setLoading(true);
    setError('');
    setQrData(null);
    try {
      const res = await getTodayArrivals(hotelId, refresh);
      setArrivals(res.data);
    } catch (err) {
      setError('Ошибка загрузки заездов');
    } finally {
      setLoading(false);
    }
  }

  async function handleGenerateQR(arrival) {
    setGenerating(arrival.booking_number + '_qr');
    setQrData(null);
    try {
      const res = await generateToken(arrival.booking_number, hotelId);
      setQrData({
        url: res.data.url,
        bookingNumber: arrival.booking_number,
        guestName: arrival.guest_name,
        room: arrival.room_number,
        expiresAt: res.data.expires_at,
        mode: 'qr',
      });
    } catch (err) {
      if (err.response?.status === 409) {
        setError('Карта уже подписана');
      } else {
        setError('Ошибка генерации QR кода');
      }
    } finally {
      setGenerating(null);
    }
  }

  async function handleTablet(arrival) {
    setGenerating(arrival.booking_number + '_tablet');
    try {
      const res = await generateToken(arrival.booking_number, hotelId);
      // Открываем карту прямо в этом же браузере
      window.location.href = res.data.url;
    } catch (err) {
      if (err.response?.status === 409) {
        setError('Карта уже подписана');
      } else {
        setError('Ошибка открытия карты');
      }
    } finally {
      setGenerating(null);
    }
  }

  function handleLogout() {
    localStorage.removeItem('rc_token');
    localStorage.removeItem('rc_user');
    navigate('/admin/login');
  }

  function formatDate(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleDateString('ru-RU', {
      day: '2-digit', month: '2-digit', timeZone: 'Europe/Moscow'
    });
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <nav className="navbar">
        <span className="navbar-brand">🏨 Рег. карты</span>
        <div className="navbar-nav">
          <Link to="/admin" className="nav-link active">Заезды</Link>
          <Link to="/admin/archive" className="nav-link">Архив</Link>
          {user?.role === 'superadmin' && (
            <Link to="/admin/guests" className="nav-link">Гости</Link>
          )}
          <button className="btn btn-outline btn-sm" onClick={handleLogout} style={{ marginLeft: 8 }}>
            Выйти
          </button>
        </div>
      </nav>

      <div className="main">
        <div className="flex items-center justify-between" style={{ marginBottom: 20 }}>
          <div>
            <h1 style={{ fontSize: 22, fontWeight: 700 }}>Заезды сегодня</h1>
            <p style={{ color: '#6b7280', fontSize: 14, marginTop: 2 }}>
              {new Date().toLocaleDateString('ru-RU', { weekday: 'long', day: 'numeric', month: 'long' })}
            </p>
          </div>
          <button className="btn btn-outline btn-sm" onClick={() => loadArrivals(true)}>🔄 Обновить</button>
        </div>

        <div className="card" style={{ marginBottom: 20 }}>
          <label className="label">Отель</label>
          <select className="input" value={hotelId} onChange={e => setHotelId(Number(e.target.value))}>
            {HOTELS.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
          </select>
        </div>

        {error && <div className="alert alert-error" onClick={() => setError('')}>{error}</div>}

        {/* QR Modal */}
        {qrData && qrData.mode === 'qr' && (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 1000, padding: 16,
          }}>
            <div className="card" style={{ maxWidth: 380, width: '100%', textAlign: 'center' }}>
              <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 4 }}>QR-код для гостя</h2>
              <p style={{ color: '#6b7280', fontSize: 14, marginBottom: 4 }}>{qrData.guestName}</p>
              <p style={{ color: '#6b7280', fontSize: 13, marginBottom: 20 }}>Номер {qrData.room}</p>
              <div style={{
                display: 'flex', justifyContent: 'center', marginBottom: 16,
                padding: 16, background: '#fff', borderRadius: 8, border: '1px solid #e5e7eb',
              }}>
                <QRCode value={qrData.url} size={220} level="M" includeMargin />
              </div>
              <p style={{ fontSize: 12, color: '#9ca3af', marginBottom: 20 }}>
                Действует 60 минут · Одноразовый
              </p>
              <button className="btn btn-outline w-full" onClick={() => setQrData(null)}>
                Закрыть
              </button>
            </div>
          </div>
        )}

        {loading ? (
          <div className="flex justify-center" style={{ padding: 60 }}>
            <div className="spinner" />
          </div>
        ) : arrivals.length === 0 ? (
          <div className="empty">
            <div className="empty-icon">🏨</div>
            <p>Нет заездов на сегодня</p>
          </div>
        ) : (
          <div>
            <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 12 }}>
              Всего: <strong>{arrivals.length}</strong> · Подписано: <strong>{arrivals.filter(a => a.signed).length}</strong>
            </p>
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Номер</th>
                    <th>Гость</th>
                    <th className="hide-mobile">Телефон</th>
                    <th className="hide-mobile">Выезд</th>
                    <th>Статус</th>
                    <th>Действия</th>
                  </tr>
                </thead>
                <tbody>
                  {arrivals.map(a => (
                    <tr key={a.booking_number}>
                      <td><strong>{a.room_number}</strong></td>
                      <td>{a.guest_name || '—'}</td>
                      <td className="hide-mobile" style={{ fontSize: 13, color: '#6b7280' }}>
                        {a.guest_phone || '—'}
                      </td>
                      <td className="hide-mobile" style={{ fontSize: 13 }}>
                        {formatDate(a.checkout)}
                      </td>
                      <td>
                        {a.signed
                          ? <span className="badge badge-green">✓ Подписана</span>
                          : <span className="badge badge-gray">Ожидает</span>
                        }
                      </td>
                      <td>
                        {a.signed ? (
                          <span style={{ fontSize: 13, color: '#9ca3af' }}>—</span>
                        ) : (
                          <div style={{ display: 'flex', gap: 6 }}>
                            <button
                              className="btn btn-primary btn-sm"
                              onClick={() => handleGenerateQR(a)}
                              disabled={generating === a.booking_number + '_qr'}
                              title="Показать QR гостю"
                            >
                              {generating === a.booking_number + '_qr' ? '...' : '📱 QR'}
                            </button>
                            <button
                              className="btn btn-success btn-sm"
                              onClick={() => handleTablet(a)}
                              disabled={generating === a.booking_number + '_tablet'}
                              title="Открыть на планшете"
                            >
                              {generating === a.booking_number + '_tablet' ? '...' : '✍️ Планшет'}
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
